import { useProfileContext } from 'hooks/context/useProfileContext'
import { useAccountPreferencesQuery } from 'hooks/queries/useAccountPreferencesQuery'

export const useUserCurrentCurrency = () => {
  const { data: accountPreferences } = useAccountPreferencesQuery()
  const { profile } = useProfileContext() || {}
  const { currencyCode: profileCurrency } = profile || {}
  const preferredCurrency = accountPreferences?.currency

  return preferredCurrency || profileCurrency
}
